import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class TextAreaService {

  constructor(
    @Inject('TEXT_AREA_FORMAT') private format: string = 'M',
    @Inject('TEXT_AREA_SHOW_LABEL') private showLabel: boolean = true,
    @Inject('TEXT_AREA_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('TEXT_AREA_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('TEXT_AREA_SUBMITTED') private submitted: boolean = true,
    @Inject('TEXT_AREA_VALIDATOR_ALERT') private validatorAlert: boolean = false
  ) {
  }

  public getFormat(): string {
    return this.format;
  }
  public getShowLabel(): boolean {
    return this.showLabel;
  }
  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  public getValidatorAlert(): boolean {
    return this.validatorAlert;
  }
  
  
}